<template>
  <div v-if="$grantAccess($me, 'updateAny', 'survey-planning')">
    <v-layout v-if="!revisionsFetched" justify-end>
      <v-btn small outlined color="primary lighten-1" @click="setupRevisions" :loading="revisionsPending" :disabled="dataPending || revisionsPending">
        <v-icon left>history</v-icon>
        Revisions
      </v-btn>
    </v-layout>

    <template v-else-if="hasRevisions">
      <span>Revisions</span>
      <v-layout>
        <v-slider
          class="pibot-revision-slider"
          v-model="curRevisionStep"
          color="primary darken-1"
          track-color="primary darken-1"
          ticks="always"
          tick-size="4"
          :tick-labels="tickLabels"
          :step="100 / (revisionsAndNow.length - 1)"
          @change="changedRevSelect"
          :disabled="dataPending"
          :thumb-label="false"
        />

        <!-- <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn text icon color="gray" v-on="on" @click="dismissRevisions">
              <v-icon>cancel</v-icon>
            </v-btn>
          </template>
          <span>Dismiss revisions</span>
        </v-tooltip> -->
      </v-layout>
    </template>

    <template v-else>
      <span>No revisions available</span>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import { planningMixin } from '../utils/mixins/planning.mixin'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'pibot-survey-planning-revisions',
  mixins: [planningMixin],
  data () {
    return {
      curRevisionStep: null,
      surveyDataCache: null
    }
  },
  computed: {
    ...mapState({
      dataPending: state => state.surveys.dataPending,
      revisionsPending: state => state.surveys.revisionsPending,
      revisionsFetched: state => state.surveys.revisionsFetched,
      revisions: state => state.surveys.revisions,
      revisionData: state => state.surveys.revisionData,
      surveyData: state => state.surveys.surveyData
    }),
    hasRevisions () {
      return this.revisions.length > 0
    },
    tickLabels () {
      const tickLabels = this.revisions.map(r => {
        let format = 'D MMM YY HH:mm'
        if (this.inThisDay(r)) format = 'ddd HH:mm'
        else if (this.inThisWeek(r)) format = 'ddd HH:mm'
        else if (this.inThisMonth(r)) format = 'ddd D HH:mm'
        else if (this.inThisYear(r)) format = 'D MMM HH:mm'

        return moment(r).format(format)
      })

      tickLabels.push('Now')

      return tickLabels
    },
    revisionsAndNow () {
      const revisions = JSON.parse(JSON.stringify(this.revisions))
      revisions.push(parseInt(moment().format('x')))
      return revisions
    }
  },
  methods: {
    ...mapMutations({
      setSurveyData: 'surveys/setSurveyData',
      setRevisionsFetchedState: 'surveys/setRevisionsFetchedState',
      setIsRevisionDataState: 'surveys/setIsRevisionDataState'
    }),
    ...mapActions({
      fetchRevisions: 'surveys/socket_fetchRevisions',
      fetchRevisionData: 'surveys/socket_fetchRevisionData'
    }),
    setupRevisions () {
      this.fetchRevisions()
        .then(() => {
          if (this.hasRevisions) {
            // Set the current step to one before 'Now'
            const steps = 1
            /**
             * Calculate a number from 0 - 100 to set the slider step, starting from the end.
             * Divides 100 by the length of all options on the slider.
             * This gets multiplied by the length of all options excluding 'Now'
             * and the number of steps.
             */
            this.curRevisionStep = (100 / (this.revisionsAndNow.length - 1)) * (this.revisionsAndNow.length - 1 - steps)
            this.changedRevSelect(this.curRevisionStep)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    inThisYear (timestamp) {
      return moment().format('YYYY') === moment(timestamp).format('YYYY')
    },
    inThisMonth (timestamp) {
      return moment().format('M') === moment(timestamp).format('M')
    },
    inThisWeek (timestamp) {
      return moment().format('W') === moment(timestamp).format('W')
    },
    inThisDay (timestamp) {
      return moment().format('DDD') === moment(timestamp).format('DDD')
    },
    changedRevSelect (newValue) {
      // Find index of corresponding timestamp
      const tsIndex = this.revisionsAndNow.findIndex((r, i) => {
        /**
         * Returns true if,
         * the current index is the last item,
         * or
         * 'newValue' is equal to 100 divided by the number of options, excluding 'Now',
         * multiplied by the current index in the loop.
         */
        return i === (this.revisionsAndNow.length - 1) || newValue === (100 / (this.revisionsAndNow.length - 1)) * i
      })

      // If this is the last item ('Now'), revert to the cache
      if (tsIndex === this.revisionsAndNow.length - 1) {
        this.setIsRevisionDataState(false)
        this.processRevisionData(this.surveyDataCache)
        return
      }

      this.setIsRevisionDataState(true)
      const timestamp = this.revisions[tsIndex]

      if (!timestamp) return console.error(`timestamp: ${timestamp}`)

      // find corresponding data
      const revisionData = this.revisionData[timestamp]

      if (revisionData) { // Revision data for selected timestamp available, continue as usual
        this.processRevisionData(revisionData)
      } else { // No data available, fetch it first
        this.fetchRevisionData(timestamp)
          .then(this.processRevisionData)
          .catch((error) => {
            console.error(error)
          })
      }
    },
    processRevisionData (revisionData) {
      if (!this.surveyDataCache) this.surveyDataCache = JSON.parse(JSON.stringify(this.surveyData))
      this.setSurveyData(revisionData)
      this.incrChanges()
    }
    // dismissRevisions () {
    //   this.setSurveyData(this.surveyDataCache)
    //   this.surveyDataCache = null
    //   this.setRevisionsFetchedState(false)
    // }
  }
}
</script>
